import { DataQuarterSelectionType, ResolvedSnapshotMatches } from './types';

export const createDefaultDataQuarterSelection = (): DataQuarterSelectionType => ({
  selectedQuarterSlug: null,
  includePriorCompetitors: true,
});

export const areDataQuarterSelectionsEqual = (
  left?: DataQuarterSelectionType | null,
  right?: DataQuarterSelectionType | null
) => {
  const normalizedLeft: DataQuarterSelectionType = {
    selectedQuarterSlug: left?.selectedQuarterSlug ?? null,
    includePriorCompetitors: left?.includePriorCompetitors ?? true,
  };
  const normalizedRight: DataQuarterSelectionType = {
    selectedQuarterSlug: right?.selectedQuarterSlug ?? null,
    includePriorCompetitors: right?.includePriorCompetitors ?? true,
  };

  return (
    normalizedLeft.selectedQuarterSlug === normalizedRight.selectedQuarterSlug &&
    normalizedLeft.includePriorCompetitors === normalizedRight.includePriorCompetitors
  );
};

type SnapshotSelectionOptions = {
  communityId?: number | null;
  competitorIds?: number[];
};

type SnapshotMatches = ResolvedSnapshotMatches;

const normalizeCompetitorIds = (matches: SnapshotMatches, competitorIds?: number[]) => {
  const base =
    competitorIds && competitorIds.length
      ? competitorIds
      : matches.competitorMatches.map((match) => match.competitorId);

  return Array.from(new Set(base.filter((value) => !Number.isNaN(value)))).sort((a, b) => a - b);
};

export const createSnapshotsByCommunityMap = (
  selection: DataQuarterSelectionType,
  matches: SnapshotMatches,
  options: SnapshotSelectionOptions = {}
) => {
  const includePrior = selection.includePriorCompetitors ?? true;
  const map: Record<number, string | null> = {};
  const { communityId } = options;
  const competitorIds = normalizeCompetitorIds(matches, options.competitorIds);

  if (communityId) {
    map[communityId] = matches.communityMatch?.snapshot?.uuid ?? null;
  }

  competitorIds.forEach((competitorId) => {
    const match = matches.competitorMatches.find((candidate) => candidate.competitorId === competitorId);

    if (!match) {
      map[competitorId] = null;
      return;
    }

    if (!includePrior && !match.isCurrentQuarter) {
      map[competitorId] = null;
      return;
    }

    map[competitorId] = match.snapshot?.uuid ?? null;
  });

  return map;
};
